import { Skeleton, SkeletonCard, SkeletonText } from "./Skeleton";

interface FormPageSkeletonProps {
  variant?: "form" | "detail";
  lines?: number;
}

export const FormPageSkeleton = ({
  variant = "form",
  lines = 4,
}: FormPageSkeletonProps) => {
  if (variant === "detail") {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-1/3" />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    );
  }
  return (
    <div className="space-y-4">
      <Skeleton className="h-8 w-1/3" />
      <SkeletonText lines={lines} />
      <Skeleton className="h-10 w-32" />
    </div>
  );
};
